export default {
  addOnlineConnectionListener: function addOnlineConnectionListener(callback) {
    window.addEventListener('online', function () {
      callback();
    });
  }
};